
import ButtonComp from "../common/ButtonComp"
import PromptDialog from "../PromptDialog";
import { useTranslation } from "react-i18next";
import nft_tradImg_left from "../../assets/images/nft_trad_left.png"
import nft_tradImg_right from "../../assets/images/nft_trad_right.png"
import { Field, Toast } from "react-vant";
import { useState } from "react";
import "./nft.less"
import { apiNftTrade } from "../../api/mining"

interface PropType {
    callBack?: Function
}
const NftTradDialog = ({ callBack }: PropType) => {
    const { t } = useTranslation();
    const [digit, setDigit] = useState<any>(null);
    const [errorText, setErrorText] = useState<string>("");
    const [refDom, setRefDom] = useState<boolean>(false);
    const verifyHandle = async () => {
        const toast = Toast.loading({
            message: t("components.usdt_transform.verifying"),
            forbidClick: true,
            duration: 0
        })
        try {
            const res = await apiNftTrade(+digit)
            toast.clear()
            switch (res.code) {
                case '0':
                    setRefDom(true)
                    setErrorText(t("components.usdt_transform.v_success"))
                    break;
                default:
                    setRefDom(true)
                    setErrorText(t("components.usdt_transform.v_reject"))

            }
        } catch (e: any) {
            toast.clear()
            if (e.response.data.code === '-1') {
                setRefDom(true)
                setErrorText(t("components.usdt_transform.v_reject"))
            }

        }

    }
    return (
        <>
            <PromptDialog teleport={document.querySelector('body')} isFull={true} isClose title={t("components.usdt_transform.nft_trad")} dialog={true} setDialog={() => {
                callBack && callBack()
            }} text='' className="customClassName">
                <div className=''>
                    <p className='text-[14px] text-[#333] text-center'>{t("components.usdt_transform.p_s_t")}</p>
                    <div className="img w-full my-[20px] h-[90px] flex">
                        <img onClick={() => {
                            const url = 'https://magiceden.io/collections/bsc/0x7a1Be56dBA9E2E09d0E86b4dD2f4BFA3049a2268'
                            window.open(url)
                        }} className="w-[50%] cursor-pointer" src={nft_tradImg_left} alt="" />
                        <img onClick={() => {
                            const url = 'https://magiceden.io/collections/bsc/0x30192E742C33101e7dc9f27676bac592F80688a4?gr='
                            window.open(url)
                        }} className="w-[50%] cursor-pointer" src={nft_tradImg_right} alt="" />
                    </div>

                    <p className='text-[14px] text-[#333] text-center mb-[10px]'>{t("components.usdt_transform.i_t_i_n")}</p>

                    {/* <Field placeholder={t("components.usdt_transform.e_t_t_id_2")} value={digit} type="number" label="" onChange={setDigit} /> */}
                    <ButtonComp width={174} height={36} mt={20} callBack={verifyHandle} title={t("task.verify")}></ButtonComp>

                </div>
            </PromptDialog>

            <PromptDialog teleport={document.querySelector('body')} className="customClassName" title={t("other.attention")} dialog={refDom} setDialog={setRefDom} callback={() => { setRefDom(false) }} text={errorText}></PromptDialog>
        </>
    )
}


export default NftTradDialog